import { TenantSettings } from '../tenant-settings.types';

export const urbanIndexTenantSettings: TenantSettings = {
  appName: 'The Big Data Showroom',
  companyDisplayName: 'Urban Index',
  logoUrl: 'assets/urban-index-logo.png',
  logoAlt: 'The Big Data Showroom',
  primaryColor: '#1e88e5',
  primaryTextColor: '#ffffff',
  enableUserDataRequests: true,
};
